import React, { Component } from "react";
import COLORS from "scss/colors.module.scss";
import { getHeaderIcon } from "../list/views/table/helpers/getHeaderIcon";
import ColorsList from "app/common/components/input/ColorsList";
import * as mui from "@material-ui/icons";

import {
  MdArrowDropDown,
  MdContentCopy,
  MdInfo,
  MdDelete,
} from "react-icons/md";
import { FiShare } from "react-icons/fi";
import { FaCheck, FaSlack } from "react-icons/fa";
import Paper from "@material-ui/core/Paper";
import { observer } from "mobx-react";
import SharePopup from "app/Pack/Share/SharePopup";
import { ClickAwayListener, Popover, Popper } from "@material-ui/core";

import synonyms from "./synonyms";
import Search from "app/common/components/input/Search";
import styled from "styled-components";
import autoBind from "auto-bind";
import { debounce } from "lodash";
import { IoMdDownload } from "react-icons/io";

if (process.env.NODE_ENV !== "production") {
  Object.keys(synonyms).forEach((icon) => {
    if (!mui[icon]) {
      throw new Error(`The icon ${icon} does no longer exist.`);
    }
  });
}

const allIcons = Object.keys(mui)
  .filter(
    (x) =>
      !x.endsWith("Outlined") &&
      !x.endsWith("Rounded") &&
      !x.endsWith("TwoTone") &&
      !x.endsWith("Sharp")
  )
  .map((key) => {
    let tag;
    if (key.indexOf("Outlined") !== -1) {
      tag = "Outlined";
    } else if (key.indexOf("TwoTone") !== -1) {
      tag = "Two tone";
    } else if (key.indexOf("Rounded") !== -1) {
      tag = "Rounded";
    } else if (key.indexOf("Sharp") !== -1) {
      tag = "Sharp";
    } else {
      tag = "Filled";
    }

    let searchable = key.replace(/(Outlined|TwoTone|Rounded|Sharp)$/, "");
    if (synonyms[searchable]) {
      searchable += ` ${synonyms[searchable]}`;
    }

    const icon = {
      key,
      tag,
      searchable,
    };
    return icon;
  });
class PackName extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popupVisible: props.isDefaultOpen || false,
      isInputFocused: false,
      colors: COLORS.HEADER_BACKGROUNDS.split(","),
      icons: [
        "fas fa-table",
        "fas fa-table-tennis",
        "fas fa-tablet",
        // "fas fa-tablet-alt",
        "fas fa-tablets",
        // "fas fa-tachometer-alt",
        "fas fa-tag",
        // "fas fa-tags",
        "fas fa-tape",
        "fas fa-tasks",
        "fas fa-taxi",
        "fas fa-terminal",
        "fas fa-text-height",
        "fas fa-text-width",
        "fas fa-th",
        // "fas fa-th-large",
      ],
      searchText: "",
    };
    autoBind(this);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
    this.setState({ anchorEl: node });
  }

  handleClickOutside(event) {
    this.setState({ popupVisible: false });
    this.props.onClose?.();
    event?.stopPropagation?.();
  }

  getListItem(icon, name, callback = () => {}) {
    return (
      <div className="listItem" onClick={callback}>
        <div>{icon}</div>
        <div className="itemName">{name}</div>
      </div>
    );
  }

  componentDidMount() {
    this.setState({ popupVisible: this.props.isDefaultOpen || false });
    if (this.props.isDefaultOpen) {
      this.props.onOpen?.();
    }
  }

  showPackDescription() {
    this.handleClickOutside({});
    if (this.packDescriptionWindow) {
      this.packDescriptionWindow.destroy();
    }

    this.packDescriptionWindow = Ext.create("TL.packs.help.Window", {
      width: 850,
      height: 500,
      helpTips: PACK["help_tips"],
      isAdmin: PACK["is_admin"],
      packId: PACK["id"],
    });

    this.packDescriptionWindow.show();
  }

  openPackEditPopup = (e) => {
    e.stopPropagation();
    // document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({
      popupVisible: true,
      anchorEl: e.currentTarget,
    });
    this.props.onOpen?.();
  };

  setSearchText = debounce((val) => {
    this.setState({ searchText: val });
  }, 200);

  handleSearchTextChange(e) {
    this.setSearchText(e.target.value);
  }

  render() {
    const {
      store,
      Button = (
        <>
          <span style={{ paddingRight: 6 }}>
            {getHeaderIcon(this.props.icon, COLORS.PRIMARY_COLOR)}
          </span>
          {this.props.packName}
          <MdArrowDropDown
            className="h-100"
            style={{
              fontSize: 22,
              marginLeft: 3,
            }}
          />
        </>
      ),
    } = this.props;

    return (
      <div
        className="align-self-center"
        style={{
          flex: 1,
          textAlign: "center",
          fontSize: 20,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <span
          className="heading"
          onClick={this.openPackEditPopup}
          ref={this.setWrapperRef}
        >
          {Button}
        </span>
        {/* <MdInfo
          className="packInfo"
          style={{
            fontSize: 14,
            marginLeft: 5,
          }}
          color={COLORS.PRIMARY_COLOR}
          onClick={this.showPackDescription.bind(this)}
        /> */}
        <Popover
          open={this.state.popupVisible}
          anchorEl={this.state.anchorEl}
          // style={{ zIndex: 1111 }}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <ClickAwayListener onClickAway={this.handleClickOutside}>
            <Paper elevation={5}>
              <input
                autoFocus
                value={this.props.packName}
                disabled={!store.isAdmin}
                onChange={(e) => {
                  this.props.changePackName(e.target.value);
                }}
                onFocus={(e) => {
                  if (this.props.isDefaultOpen) {
                    e.target.select();
                  }
                  if (!this.state.isInputFocused)
                    this.setState({ isInputFocused: true });
                }}
                onBlur={() => {
                  if (this.state.isInputFocused)
                    this.setState({ isInputFocused: false });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    this.handleClickOutside();
                  }
                }}
                style={{
                  borderRadius: 2,
                  border: this.state.isInputFocused ? "1px solid #ddd" : "0px",
                  color: COLORS.TEXT_COLOR,
                  textAlign: "center",
                  margin: 5,
                  height: 35,
                  width: 250,
                  outline: "none",
                }}
              />
              {store.isAdmin && (
                <>
                  <ColorsList
                    colors={this.state.colors}
                    value={this.props.themeColor}
                    onChange={this.props.changeThemeColor}
                    type="circle"
                    size="large"
                  />
                  <SearchWrapper>
                    <Search
                      placeholder="Search Icons"
                      onChange={this.handleSearchTextChange}
                      elevation={0}
                    />
                  </SearchWrapper>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      maxWidth: 250,
                      maxHeight: 150,
                      backgroundColor: COLORS.PACK_ICONS_BACKGROUND,
                      margin: "0 5px 5px 5px",
                      padding: 5,
                      overflow: "auto",
                    }}
                  >
                    {allIcons
                      .filter((icon) =>
                        this.state.searchText
                          ? icon.searchable.includes(this.state.searchText)
                          : true
                      )
                      .sort()
                      .map((icon, index) => {
                        return (
                          <Icon
                            isHighlighted={icon.key === this.props.icon}
                            icon={icon.key}
                            key={icon.key}
                            onClick={this.props.changeIcon}
                            themeColor={this.props.themeColor}
                          />
                        );
                      })}
                  </div>
                  {!this.props.isShareHidden && (
                    <div>
                      {this.getListItem(
                        <FiShare
                          style={styles.icon}
                          size={18}
                          color={COLORS.TEXT_COLOR}
                        />,
                        "Share",
                        (e) => {
                          this.handleClickOutside({});
                          this.props.store.shareStore.handleClick({
                            currentTarget: e.target,
                          });
                        }
                      )}
                    </div>
                  )}
                </>
              )}
              <div>
                {/* {this.getListItem(
                  <MdInfo
                    style={styles.icon}
                    size={18}
                    color={COLORS.TEXT_COLOR}
                  />,
                  "Pack description",
                  this.showPackDescription.bind(this)
                )} */}
                {store.isAdmin && (
                  <>
                    {/* {this.getListItem(
                      <MdContentCopy
                        style={styles.icon}
                        size={18}
                        color={COLORS.TEXT_COLOR}
                      />,
                      "Duplicate pack",
                      () => {}
                    )}
                    {this.getListItem(
                      <FaSlack
                        style={styles.icon}
                        size={18}
                        color={COLORS.TEXT_COLOR}
                      />,
                      "Slack notifications",
                      () => {}
                    )} */}

                    {this.getListItem(
                      <IoMdDownload
                        style={styles.icon}
                        size={18}
                        color={COLORS.TEXT_COLOR}
                      />,
                      "Export Pack",
                      (e) => {
                        this.handleClickOutside({});
                        this.props?.store?.exportPack(this.props?.packData);
                      }
                    )}
                    {this.getListItem(
                      <MdDelete
                        style={styles.icon}
                        size={18}
                        color={COLORS.TEXT_COLOR}
                      />,
                      "Delete pack",
                      (e) => {
                        this.handleClickOutside({});
                        this.props.store.deletePack();
                      }
                    )}
                  </>
                )}
              </div>
            </Paper>
          </ClickAwayListener>
        </Popover>
      </div>
    );
  }
}

const Icon = React.memo(function ({
  icon,
  isHighlighted,
  themeColor,
  onClick,
}) {
  const Icon = mui[icon];

  return (
    <IconWrapperStyled
      isHighlighted={isHighlighted}
      themeColor={themeColor}
      onClick={() => onClick(icon)}
    >
      {!Icon ? (
        getHeaderIcon(
          icon,
          isHighlighted ? COLORS.PRIMARY_COLOR : COLORS.TEXT_COLOR
        )
      ) : (
        <Icon />
      )}
    </IconWrapperStyled>
  );
});

const IconWrapperStyled = styled.div`
  background-color: ${({ isHighlighted, themeColor }) =>
    isHighlighted ? themeColor : null};
  opacity: 0.8;
  width: 38px;
  height: 38px;
  border-radius: 3px;
  margin: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export default observer(PackName);

const styles = {
  icon: {
    marginTop: -5,
  },
};

const SearchWrapper = styled.div`
  padding: 5px;
  margin: 5px 5px 0px 5px;
  background-color: ${COLORS.PACK_ICONS_BACKGROUND};
`;
